import { useRates } from "@/lib/hooks/use-rates";
import { useWidget } from "@/lib/hooks/use-widget";
import { useMemo } from "react";

const tokenSymbolMap: Record<string, string> = {
  "WBTC.E": "WBTC",
  FXVERSE: "VERSE",
};

export const useTotalBalance = () => {
  const { rates } = useRates();
  const { balances } = useWidget();

  const totalBalance = useMemo(() => {
    return (
      Object.values(balances).reduce((prev, tokens) => {
        const totalTokensBalance = tokens.reduce((acc, token) => {
          const symbol = token.symbol.toUpperCase();
          const mappedSymbol = tokenSymbolMap[symbol] ?? symbol;

          const rate = rates?.[mappedSymbol];
          const balance = Number(token.balanceFormatted);

          if (isNaN(rate) || isNaN(balance)) return acc;

          return rate * balance + acc;
        }, 0);

        if (isNaN(totalTokensBalance)) return prev;

        return prev + totalTokensBalance;
      }, 0) ?? 0
    );
  }, [balances, rates]);

  return totalBalance;
};
